import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/eventSchedule/importer/eventScheduleImporterSelectors';
import EventScheduleService from 'src/modules/eventSchedule/eventScheduleService';
import fields from 'src/modules/eventSchedule/importer/eventScheduleImporterFields';
import { i18n } from 'src/i18n';

const eventScheduleImporterActions = importerActions(
  'EVENTSCHEDULE_IMPORTER',
  selectors,
  EventScheduleService.import,
  fields,
  i18n('entities.eventSchedule.importer.fileName'),
);

export default eventScheduleImporterActions;